import { useAuth0 } from "@auth0/auth0-react";
import { UserIcon } from "../../images/Icons";
import styles from './Auth.module.css';
import { Browser } from "@capacitor/browser";
import { callbackUri, rootUrl } from "../../AppSettings";
import { DropDownButton } from "../../components/DropDownButton";
import userImg from '../../images/user.svg'
import { useNavigate } from "react-router-dom";
import { setLogoutRequested } from "../currentPartyEvent/currentPartyEventSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const LoginPanel = () => {
    const { loginWithRedirect, isAuthenticated, logout, user } = useAuth0();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const login = async () => {
        await loginWithRedirect({
          
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self"
            });
          }
        });
      };
    const doLogout = async () => {
        dispatch(setLogoutRequested(true))
        await logout({
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self",
            });
          },
          logoutParams: {
            returnTo: callbackUri
          }
        });
      };
    if (isAuthenticated) {
        return (
          <>
            <DropDownButton imgSrc={userImg} imgAlt="User Menu">
              <div className={styles.linkButton} onClick={doLogout}>Sign out</div>
              <div className={styles.linkButton} onClick={()=> {navigate('/Merchandise')}}>Merchandise</div>
              <div className={styles.linkButton} onClick={() => {navigate('/AccountDetails')}}>Account details</div>
            </DropDownButton>
           
            </>
        )
    } else {
        return (
            <div className={styles.linkButton} onClick={login}>
                <UserIcon/>
                <span>Sign In</span>
            </div>
        )
    }
}